module.exports = __webpack_public_path__ + "static/media/dummy_small.87a42d6d.png";